module.exports = __webpack_public_path__ + "img/CollaborativeAutomation.4b187236.jpg";